import { ILicenceProfile } from "../../api/ILicenceProfile";
import { GetLicenceVersionUrl } from "../../external-apps/Config";
import EpaCard from "../../leap-components/EpaCard";
import EpaField from "../../leap-components/EpaField";
import { EpaFieldHtml2 } from "../../leap-components/EpaFieldHtml2";

interface ILicenceDetailsProps {
  licenceProfile: ILicenceProfile;
}

export const ActiveApplicationDetails = ({
  licenceProfile,
}: ILicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <EpaFieldHtml2
        label={"Reg No."}
        element={
          <a
            href={GetLicenceVersionUrl(
              licenceProfile.type,
              licenceProfile.profileNo,
              licenceProfile.active_application_licence_id,
              licenceProfile.active_application_licence_regno
            )}
            target="_blank"
          >
            {licenceProfile.active_application_licence_regno}
          </a>
        }
      />
      <EpaField
        label={"Application Date"}
        value={licenceProfile.active_application_date}
      />
      <EpaField
        label={"Status"}
        value={licenceProfile.active_application_status}
      />
    </div>
  ) as JSX.Element;

  return (
    <EpaCard
      title={"Active Authorisation Application"}
      content={bodyElements}
    />
  );
};
